import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import image1 from "../../images/testimonial/1.webp";
import image2 from "../../images/testimonial/2.webp";
import image3 from "../../images/testimonial/3.webp";

import Shape1 from "../../images/testimonial/star.svg";
import Shape2 from "../../images/testimonial/star-1.svg";
import Shape3 from "../../images/testimonial/quote.webp";

const TestimonialData = [
  {
    id: "01",
    text: "The Cash Flow Summit completely transformed how I approach my business finances. The strategies I learned helped me increase my operational cash flow by 47% in just 6 months.",
    subtitle: "CEO, TechSolutions India",
    title: "Rajiv Mehta",
    image: image1,
  },
  {
    id: "02",
    text: "As a first-time entrepreneur, the summit provided practical strategies that I could implement immediately. My business has seen a 200% growth in working capital efficiency.",
    subtitle: "Founder, EcoStyle Clothing",
    title: "Priya Sharma",
    image: image2,
  },
  {
    id: "03",
    text: "The networking opportunities were invaluable. I connected with three investors who are now backing my expansion plans. This summit is truly a game-changer.",
    subtitle: "Director, HealthTech Innovations",
    title: "Vikram Patel",
    image: image3,
  },
];

const TestimonialSection = () => {
  const ClickHandlar = () => {
    window.scrollTo(10, 0);
  };

  const settings = {
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  };
  return (
    <section className="testimonial-section section-padding">
      <div className="container">
        <div className="row align-content-center">
          <div className="col-xl-4 col-12">
            <div className="section-title">
              <span>Testimonial</span>
              <h2>What Our Attendees Say</h2>
              <p>
                Hear from business leaders who have transformed their
                organizations through the Cash Flow Summit.
              </p>
              <div className="testimonial-btn">
                <a
                  href="https://www.jsaonline.in/testimonials"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="theme-btn"
                >
                  Read More Success Stories <i className="ti-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-8 col-12">
            <div className="testimonial-slider">
              <Slider {...settings}>
                {TestimonialData.map((Testimonials, tky) => (
                  <div className="item" key={tky}>
                    <div className="client">
                      <div className="image">
                        <img src={Testimonials.image} alt="" />
                      </div>
                      <div className="text">
                        <h2>{Testimonials.title}</h2>
                        <span>{Testimonials.subtitle}</span>
                      </div>
                    </div>
                    <div className="reting">
                      <ul>
                        <li>
                          <img src={Shape1} alt="" />
                        </li>
                        <li>
                          <img src={Shape1} alt="" />
                        </li>
                        <li>
                          <img src={Shape1} alt="" />
                        </li>
                        <li>
                          <img src={Shape1} alt="" />
                        </li>
                        <li>
                          <img src={Shape2} alt="" />
                        </li>
                      </ul>
                      <span>(5.0)</span>
                    </div>
                    <p>{Testimonials.text}</p>
                    <div className="icon">
                      <img src={Shape3} alt="" />
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
